import React from "react";
import emptyFolder from "../../assets/svg/emptyFile.svg";
import emptyFolderDarkMode from "../../assets/svg/EmptyFolderDarkMode.svg";
import { useTheme } from "../../hooks/useTheme";
const EmptyFolder = ({ title = "Trash is Empty", subTitle = "-" }) => {
  const { isDark, toggleTheme } = useTheme("dark");
  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <img height={200} src={isDark ? emptyFolderDarkMode : emptyFolder} />
      <h2 className="font-color">{title}</h2>
      <p className="font-color">{subTitle}</p>
    </div>
  );
};

export default EmptyFolder;
